import React, { Component, createRef} from "react";
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import { Modal } from 'bootstrap';
import config from "../config";
import Login from "./Login";
import MainHeader from "../component/Header/MainHeader";
import DataTableGrid from "../component/dataTable";
import pdata from "../data.json";
import filterData from "../filter.json";
import * as XLSX from "xlsx";
import { ulid } from 'ulid';
import moment from 'moment';
import axios from 'axios';
import DataTable from "react-data-table-component";
import { DebounceInput } from 'react-debounce-input';

class AopaCode extends Component {

    constructor(props) {
        super(props);
        this.state = {
			userGuid:localStorage.getItem('user_id'),
			CreatedBy:localStorage.getItem('username'),
			role:localStorage.getItem('role'),
			policyData:pdata['policyData'],
			showUpdatePolicy:false,
			showUpdateImage:false,
			isHomePage:true,
			userPage1:false,
			userPage2:false,
			editCompany:false,
			editUser:false,
			fData:filterData,
			LCode:'',
			
			LCodeDetails:[],
			HcpcsDetails:[],
			HcpcsDetails1:[],
			HcpcsDetails2:[],
			
			selectedSetName:'',
			dataSets:[],
			dataSets2:[],
			setObject:[],
			editRow:[],
			combineData:[],
			showDataSets:false,
			showCombinedDataTable:false,
			currentPage: 1,
			perPage: 10,
			searchValue: "",
			highlightValue: "",
			
		}
		this.fileInputRef = createRef();
    }
	
	componentDidMount() {
		 this.loadScript();
	}
	
	loadScript() {
		$(function() {
		  $('.js-menu-toggle').click(function(e) {
			var $this = $(this);
			if ( $('#wrapper').hasClass('toggled') ) {
				$('#wrapper').removeClass('toggled');
				$('#wrapper').addClass('full-width');
				$this.removeClass('active');
			} else {
				$('#wrapper').addClass('toggled');
				$('#wrapper').removeClass('full-width');				
				$this.addClass('active');
			}
			e.preventDefault();
		  });
		});
	}
	
	getValue=(event)=>{
		let name = event.target.name;
		let value = event.target.value;
		this.setState({[event.target.name]:event.target.value});
		if(name == 'adminUserOption' && value == 'manageDataSets'){
			this.getDataSets();
			this.setState({showDataSets:true});
		}
		
		if(name == 'userData' && value == 'updatePolicy'){
			//console.log('policyData->',pdata);
			this.setState({showUpdatePolicy:true,isHomePage:false,showUpdateImage:false,userPage1:false,userPage2:false,userPage:''});
		} else if(name == 'userData' && value == 'updateImage'){
			this.setState({showUpdateImage:true,showUpdatePolicy:false,isHomePage:false,userPage1:false,userPage2:false,userPage:''});
		}
		
		if(name == 'LCode' && value != ''){
			this.state.policyData.map((val, i) => {
				//console.log('policyData->',val);
				if(val['HCPCS'] == value){	
					this.setState({LCodeDetails:val});
				}
			})
		}
		
		if(name == 'HcpcsCode' && value != ''){
			this.state.policyData.map((val, i) => {
				if(val['HCPCS'] == value){	
					this.setState({HcpcsDetails:val});
				}
			})
		}
		
		if(name == 'HcpcsCode1' && value != ''){
			this.state.policyData.map((val, i) => {
				if(val['HCPCS'] == value){	
					this.setState({HcpcsDetails1:val});
				}
			})
		}
		
		if(name == 'HcpcsCode2' && value != ''){
			this.state.policyData.map((val, i) => {
				if(val['HCPCS'] == value){	
					this.setState({HcpcsDetails2:val});
				}
			})
		}
		
		if(name == 'userPage' && value == 'byHcpcs'){
			this.setState({userPage1:true,userPage2:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
		}
		
		if(name == 'userPage' && value == 'compare'){
			this.setState({userPage2:true,userPage1:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
		}
	}
	
	viewCombineDataSet = () => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'data-sets-v2';
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data;
			if(dataSets){
				let combined = [];
				let modifiedDates = [];
				dataSets.forEach((dataSet) => {
					//console.log('dataSet->',dataSet);
					let rows = dataSet.DataSetRows || [];
					rows.forEach((row, index) => {
						if (!combined[index]) {
							combined[index] = {};
						}
						let newObj = combined[index];
						// Add keys in order (only if not already present)
						Object.keys(row).forEach((key) => {
							if (!(key in newObj) && key != 'updated_at') {
								newObj[key] = row[key];
							}
							/*  else {
								newObj[key] = row[key]; // overwrite but keep position
							} */
						});
						combined[index] = newObj;
					});
					modifiedDates.push(dataSet.ModifiedDate);
				});
				
				const latest = new Date(
				  Math.max(...modifiedDates.map(d => new Date(d.replace(' ', 'T'))))
				);
				
				this.setState({showCombinedDataTable:true,combineData:combined,isHomePage:false, combinedLastDate:latest,selectedSetName:[]});
				$("#dataSet").val('');
			}
		});
		
		//console.log('modifiedDate Rows:', modifiedDate);
	};
	
	builderOption = () => {
		
	}
	
	/* handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		const reader = new FileReader();
		let fileName = file.name;
		fileName = fileName.split("_")[0];
		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });
			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			
			const jsonData = XLSX.utils.sheet_to_json(worksheet, {
			  defval: ""
			}).map(({ __rowNum__, ...rest }) => rest);

			console.log("ExcelData:", jsonData);
			let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
			let uld = ulid();
			let fieldData = {
				"DataSetName": fileName,
				"DataSetGuid":uld,
				"Description":'',
				"CreatedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
				"ModifiedDate": moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
				"CreatedBy": 'admin',
				"DataSetRows": jsonData,
			}
			this.storeDataSet(fieldData);
			//this.setState({ excelData: jsonData });
		};
		reader.readAsArrayBuffer(file);
	}; */
	
	handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;
		const reader = new FileReader();
		const sanitizeKey = (key) => {
			return key
			.replace(/[^a-zA-Z0-9]/g, '')
			.trim();
		};

		let fileName = file.name;
		fileName = fileName.split("_")[0];
		
		reader.onload = (e) => {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: "array" });

			const sheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[sheetName];
			const jsonData = XLSX.utils.sheet_to_json(worksheet, {
				defval: ""
			}).map((row) => {
				const newRow = {};
				Object.keys(row).forEach((key) => {
					if (key === "__rowNum__") return;
					const cleanKey = sanitizeKey(key);
					newRow[cleanKey] = row[key];
				});
				newRow.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');
				return newRow;
			});
			let currentDate = new Date()
			  .toLocaleString("en-US", { timeZone: "America/New_York" })
			  .replace(",", "");

			let uld = ulid();

			let fieldData = {
			  DataSetName: fileName,
			  DataSetGuid: uld,
			  Description: '',
			  CreatedDate: moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
			  ModifiedDate: moment(	).format('YYYY-MM-DD HH:mm:ss'),
			  CreatedBy: 'admin',
			  DataSetRows: jsonData,
			};
			//console.log("fieldData:", fieldData);
			this.storeDataSet(fieldData);
			// this.setState({ excelData: jsonData });
		};

		reader.readAsArrayBuffer(file);
	};
	
	getDataSets = () => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'data-sets';
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data;
			if(dataSets){
				this.setState({dataSets:dataSets});
			}else{
				this.setState({dataSets:[]});
			}
		});
	}
	
	getDataSetsV2 = () => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'data-sets-v2';
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const dataSets = response.data;
			if(dataSets){
				this.setState({dataSets2:dataSets});
			}else{
				this.setState({dataSets2:[]});
			}
		});
	}
	
	loadDataSet = (event) => {
		let setName = event.target.options[event.target.selectedIndex].text;
		let setGuid = event.target.value;
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'data-set/'+setGuid;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			console.log('data->',data);
			this.setState({setObject:data,selectedSetName:setName,isHomePage:false,showCombinedDataTable:false});
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	loadDataSet2 = (setGuid) => {
		let ApiUrl = config.mongoApiUrl;
		let url = ApiUrl+'data-set/'+setGuid;
		let data = [];
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			const data = response.data;
			this.setState({setObject:data});
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	storeDataSet = (data) => {
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'add-data-set';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			if(res){
				let setObject = this.state.setObject;
				this.loadDataSet2(setObject.DataSetGuid);
				alert(res);
				this.getDataSets();
			}else{
				//alert('MDS Name already exist!');
			}
			const modalEl = document.getElementById('editRowPopup');
			const modal = Modal.getInstance(modalEl); // get the existing instance
			if(modal){
				modal.hide();
			}
			
		}).catch(error => {
			console.log('error::', error);
		})
	};

	uploadDataSet = () => {
		const modal = new Modal(document.getElementById('uploadSetPopup'));
		modal.show();
	};
	
	uploadDataSet2 = () => {
		this.fileInput.click();
	};
		
	handleButtonClick = () => {
		this.fileInputRef.current.click();
	};
	
	handleButtonClick2 = () => {
		this.setState({editCompany:true,editUser:false,userPage2:false,userPage1:false,userPage1:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
	};
	
	handleButtonClick3 = () => {
		this.setState({editUser:true,editCompany:false,userPage1:false,userPage2:false,userPage1:false,userData:'',showUpdatePolicy:false,isHomePage:false,showUpdateImage:false});
	};
	
	handleEdit = (row) => {
		console.log("Edit row:", row);
		this.setState({editRow:row});
		const modal = new Modal(document.getElementById('editRowPopup'));
		modal.show();
	};
	
	getColumns = () => {
		const setObject = this.state.setObject;
		let dataSetRows = 	setObject.DataSetRows ? setObject.DataSetRows : [];
		//console.log('dataSetRows->',dataSetRows);
		if (!dataSetRows || dataSetRows.length === 0) return [];

		const dynamicColumns = Object.keys(dataSetRows[0])
		  .filter((key) => key !== "updated_at")
		  .map((key) => ({
			name: key.replace(/([A-Z])/g, " $1").trim(),
			selector: (row) => row[key],
			sortable: true,
			wrap: false,
			maxWidth: "500px", 
		}));

		const actionColumn2 = {
		  name: "Actions",
		  cell: (row) => (
			<button className="btn" onClick={() => this.handleEdit(row)}>
			 <i className="fa fa-edit"></i>
			</button>
		  ),
		  ignoreRowClick: true,
		  allowOverflow: true,
		  button: true,
		};
		
		const actionColumn = {
		  name: "History",
		  selector: (row) => new Date(row.updated_at), // actual sortable value
		  sortable: true,
		  cell: (row) => (
			<span>
			  {moment(row.updated_at).format('MM-DD-YYYY h:mm A')}
			</span>
		  ),
		  ignoreRowClick: true,
		  allowOverflow: true,
		  wrap: false,
		  maxWidth: "180px", 
		};

		return [...dynamicColumns, actionColumn, actionColumn2];
	};
	
	getColumns2 = () => {
		const setObject = this.state.combineData;
		let dataSetRows = 	setObject ? setObject : [];
		//console.log('dataSetRows->',dataSetRows);
		if (!dataSetRows || dataSetRows.length === 0) return [];

		const dynamicColumns = Object.keys(dataSetRows[0]).map((key) => ({
			name: key.replace(/([A-Z])/g, " $1").trim(),
			selector: (row) => row[key],
			sortable: true,
			wrap: false,   
			maxWidth: "500px", 
		}));

		return [...dynamicColumns];
	};

	handleInputChange = (e) => {
		this.setState({ searchValue: e.target.value });
	};

	/* goToRow = (value) => {
		const setObject = this.state.setObject;
		let dataSetRows = 	setObject.DataSetRows ? setObject.DataSetRows : [];
		const { perPage, searchValue } = this.state;
		const index = dataSetRows.findIndex(
		(row) => row.HCPCS === searchValue || row.HCPCS?.includes(searchValue)
		);

		if (index === -1) {
		alert("Value not found");
		return;
		}
		const page = Math.floor(index / perPage) + 1;
		
		console.log('index->',index);
		console.log('page->',page);
		this.setState({currentPage:page, highlightValue:searchValue});
	}; */
	
	goToRow = () => {
		const dataSetRows = this.state.setObject.DataSetRows || [];
		const { perPage, searchValue } = this.state;

		const index = dataSetRows.findIndex(
		(row) =>
		  row.HCPCS === searchValue ||
		  row.HCPCS?.includes(searchValue)
		);

		if (index === -1) {
		alert("Value not found");
		return;
		}

		const page = Math.floor(index / perPage) + 1;

		this.setState((prev) => ({
		currentPage: page,
		highlightValue: searchValue,
		resetPaginationToggle: !prev.resetPaginationToggle
		}));
	};
	
	editRowUpdate = () => {
		let data = this.state.editRow;
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		if (data) {
			const updatedData = { ...data };
			Object.keys(this.state).forEach((key) => {
			  if (updatedData.hasOwnProperty(key)) {
				updatedData[key] = this.state[key];
			  }
			});

			//console.log("Updated Row:", updatedData);
			let setObject = this.state.setObject;
			let dataSetRows = setObject.DataSetRows ? setObject.DataSetRows : [];

			/* const updatedRows = dataSetRows.map((row) => {
				if (row.HCPCS === updatedData.HCPCS) {
					return updatedData; // replace matched row
				}
			  return row;
			}); */
			
			const updatedRows = dataSetRows.map((row) => {
				if (row.HCPCS === updatedData.HCPCS) {
					return {
						...updatedData,
						updated_at: moment(currentDate).format('YYYY-MM-DD HH:mm:ss')
					};
				}
				return row;
			});

			//console.log("Updated Rows:", updatedRows);

			setObject.DataSetRows = updatedRows;
			
			setObject.ModifiedDate = moment(currentDate).format('YYYY-MM-DD HH:mm:ss');
			
			this.setState({setObject:setObject});
			this.storeDataSet(setObject);
		}
	};
	
	downloadLatestData = () => {
		let setObject = this.state.setObject;
		const dataRows = setObject.DataSetRows || [];
		if (dataRows.length === 0) {
		alert("No data available to download!");
		return;
		}
		const worksheet = XLSX.utils.json_to_sheet(dataRows);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

		const dateObj = new Date(setObject.ModifiedDate);
		const month = String(dateObj.getMonth() + 1).padStart(2, "0");
		const day = String(dateObj.getDate()).padStart(2, "0");
		const year = String(dateObj.getFullYear());

		const hours = String(dateObj.getHours()).padStart(2, "0");
		const minutes = String(dateObj.getMinutes()).padStart(2, "0");
		const seconds = String(dateObj.getSeconds()).padStart(2, "0");

		const formattedDateTime = `${month}${day}${year}_${hours}${minutes}${seconds}`;
		
		const fileName = `${setObject.DataSetName || "Dataset"}_${formattedDateTime}.xlsx`;
		XLSX.writeFile(workbook, fileName);
	};
	
	downloadCombinedData = () => {
		let ModifiedDate = this.state.combinedLastDate;
		const dataRows = this.state.combineData || [];
		if (dataRows.length === 0) {
		alert("No data available to download!");
		return;
		}
		const worksheet = XLSX.utils.json_to_sheet(dataRows);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

		const dateObj = new Date(ModifiedDate);
		const month = String(dateObj.getMonth() + 1).padStart(2, "0");
		const day = String(dateObj.getDate()).padStart(2, "0");
		const year = String(dateObj.getFullYear());

		const hours = String(dateObj.getHours()).padStart(2, "0");
		const minutes = String(dateObj.getMinutes()).padStart(2, "0");
		const seconds = String(dateObj.getSeconds()).padStart(2, "0");

		const formattedDateTime = `${month}${day}${year}_${hours}${minutes}${seconds}`;
		
		const fileName = `${"CombinedDataset"}_${formattedDateTime}.xlsx`;
		XLSX.writeFile(workbook, fileName);
	};
	
	handleEditDataSet = (setObject) => {
		this.setState({DataSetGuid:setObject.DataSetGuid, DataSetName:setObject.DataSetName, FilePrefix:setObject.FilePrefix, Description:setObject.Description, DataSetNotes:setObject.DataSetNotes});
		let that = this;
		setTimeout(function(){
			const modal = new Modal(document.getElementById('DataSetsEditDetails'));
			modal.show();
		}, 1000);
	}
	
	dataSetsDetails = () => {
		const modal = new Modal(document.getElementById('DataSetsDetails'));
		modal.show();
	};
	
	uploadDataSetDetails = () => {
		let {
		  DataSetGuid,
		  DataSetName,
		  FilePrefix,
		  Description,
		  DataSetNotes,
		  DataSetNote
		} = this.state;

		//let timestamp = new Date().toISOString();
		let currentDate = new Date().toLocaleString("en-US", {timeZone: "America/New_York"}).replace(',','');
		let newEntry = `${moment(currentDate).format('MM-DD-YYYY h:mm A')} - ${DataSetNote}`;
		let updatedNotes = DataSetNotes
		  ? `${DataSetNotes}\n${newEntry}`
		  : newEntry;

		let rData = {
		  DataSetGuid,
		  DataSetName,
		  FilePrefix,
		  Description,
		  DataSetNotes: updatedNotes
		};
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'update-details';
		axios({
			method: 'POST',
			url: url,
			data: JSON.stringify(rData),
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let res = response.data;
			if(res){
				this.loadDataSet2(DataSetGuid);
				alert(res);
			}
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	downloadTemplate = () => {
		const now = new Date();
		const formattedDate = now.toLocaleString("en-US", {
		timeZone: "America/New_York",
		month: "2-digit",
		day: "2-digit",
		year: "numeric",
		hour: "numeric",
		minute: "2-digit",
		hour12: true
		}).replace(/[\/,: ]/g, "-");

		const fileName = `HCPCS_template-${formattedDate}.xlsx`;
		const data = [["HCPCS"]];
		const ws = XLSX.utils.aoa_to_sheet(data);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "Template");

		XLSX.writeFile(wb, fileName);
	};
	
	render() {
		
		const {dataMode,role,policyData,isHomePage,showUpdatePolicy,showUpdateImage,LCode,HcpcsCode,HcpcsCode1,HcpcsCode2,LCodeDetails,HcpcsDetails,HcpcsDetails1,HcpcsDetails2,fData, showDataSets,dataSets,setObject,combineData,dataSets2,currentPage} = this.state;
		
		//console.log('combineData->',combineData);
		let dataSetRows = 	setObject.DataSetRows ? setObject.DataSetRows : [];
		
		const formatRowValues = rows =>
		  rows.map(row => {
			const newRow = {};

			Object.keys(row).forEach(key => {
			  const val = row[key];
			  const num = Number(val);

			  if (!isNaN(num) && !Number.isInteger(num)) {
				newRow[key] = num.toFixed(2); // only decimals
			  } else {
				newRow[key] = val; // keep integers & others as is
			  }
			});

			return newRow;
		});
		
		dataSetRows = formatRowValues(dataSetRows);
		//console.log(formattedData);
		
		const customStyles = {
		  headCells: {
			style: {
			  fontWeight: "bold",
			  fontSize: "16px",
			},
		  },
		  cells: {
			style: {
			  fontSize: "16px",
			},
		  },
		};
		
		/* const conditionalRowStyles = [
		  {
			when: (row) => row.HCPCS === this.state.highlightValue || row.HCPCS?.includes(this.state.highlightValue),
			style: {
			  backgroundColor: "#d1ddff",
			  border: "1px solid #4a85ef",
			  fontWeight: "bold",
			},
		  },
		]; */
		
		const conditionalRowStyles = [
		  {
			when: (row) => {
			  const value = this.state.highlightValue?.toLowerCase() || "";
			  const words = value.split(" ").filter(Boolean);

			  const hcpcs = row.HCPCS?.toLowerCase() || "";

			  return words.length > 0 && words.every(word => hcpcs.includes(word));
			},
			style: {
			  backgroundColor: "#e9efff",
			  border: "1px solid #4a85ef",
			  //fontWeight: "bold",
			},
		  },
		];
		
		const columns = policyData?.length ? Object.keys(policyData[0]) : [];
		
		let filterOption = fData.map(function(val,i) {
			return (
				<option value={val[i]} key={i}>{val[i]}</option>
			);
		})
		
		let codeOption = policyData.map(function(val,i) {
			return (
				<option value={val.HCPCS} key={i}>{val.HCPCS}</option>
			);
		})
		
		let policyOption = policyData.map(function(val,i) {
			return (
				<option value={val.Policy} key={i}>{val.Policy}</option>
			);
		})
		
		let dataSetOptions = dataSets.map(function(val,i) {
			return (
				<option value={val.DataSetGuid} key={i}>{val.DataSetName}</option>
			);
		})
	
	
		let policyDataHtml = Object.entries(HcpcsDetails).map(([key, val], i) => {
		  if (i > 2) {
			return (
			  <div className="code-details2" key={key}>
				<p><b>{key}:</b></p>
				<p>{val}</p>
			  </div>
			);
		  }
		  return null;
		});
		
		//console.log('HcpcsDetails->',HcpcsDetails);
        return(
            <div className="container-fluid">
				<MainHeader builderOption = {this.builderOption}  />
				<div className="content-container">
					<div id="wrapper" className="toggled">
						<div>
							<div className="toggle toggle-btn">
								<a href="#" className="burger js-menu-toggle active" data-toggle="collapse">
									<span></span>
								</a>
							</div>
							<aside className="sidebar">
							 <div className="side-inner align-items-end" >
								<div className="sidebar-content">
									<div className="nav-content">
									  <div className="nav-header">
										<h4 className="page-title">AOPA Coding Pro</h4>
									  </div>

										{/* role === "Administrator" && (
										<div className="admin-panel">
											<h5 className="admin-title">Administrator Tools</h5>
											<div className="form-group">
												<label htmlFor="userData">Update Data</label>
												<select
												  id="userData"
												  className="form-control"
												  name="userData"
												  onChange={this.getValue}
												>
												  <option value="">Please Select</option>
												  <option value="updatePolicy">Update Policy File</option>
												  <option value="updateImage">Update Image</option>
												</select>
											</div>
											{showUpdateImage ? 
												<div className="form-group">
													<label htmlFor="LCode">Select Code</label>
													<select
													  id="LCode"
													  className="form-control"
													  name="LCode"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null}
											
											<div className="form-group">
												<label htmlFor="LCode">Manage Users</label>
												<div className="mg-user-btn">
												  <button className="btn btn-default" onClick={this.handleButtonClick2}>Add/Edit Company</button>
												</div>
												<div className="mg-user-btn">
												  <button className="btn btn-default" onClick={this.handleButtonClick3}>Add/Edit Users</button>
												</div>
											</div>
										</div>
										) */}
										
										{role === "Administrator" && (
										<div className="admin-panel">
											<div className="left-panel-fun">
												<h5 className="admin-title">User Functions</h5>
												<div className="form-group">
													<select
													  id="adminUserOption"
													  className="form-control"
													  name="adminUserOption"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  <option value="manageDataSets">Manage Data Sets</option>
													</select>
												</div>
											</div>
											{showDataSets ? 
											<div className="left-panel-fun">
												{/* Object.keys(dataSets2).length > 0 && (
												<div className="mg-view-data">
												<button className="btn btn-info" onClick={this.viewCombineDataSet}>View Full Data Set</button>
												</div>
												) */}
												<div className="mg-view-data">
												<button className="btn btn-info" onClick={this.viewCombineDataSet}>View Full Data Set</button>
												</div>
												<h5 className="admin-title">Manage Data Subsets</h5>
												<div className="form-group">
													<select
													  id="dataSet"
													  className="form-control"
													  name="dataSet"
													  onChange={this.loadDataSet}
													>
													  <option value="">Please Select</option>
													  {dataSetOptions}
													</select>
												</div>
												
												<div className="mg-upload">
												  <input type="file" accept=".xlsx, .xls" ref={(input) => (this.fileInput = input)} style={{ display: "none" }} onChange={this.handleFileUpload} />
												  <button className="btn btn-info" onClick={this.uploadDataSet}>Upload File</button>
												</div>
												
												<div className="mg-upload">
												  <button className="btn btn-info" onClick={this.downloadTemplate}>Download Template</button>
												</div>
												
												{this.state.selectedSetName && dataSetRows ?
												<div className="mg-find-code">
													<input className="form-control mb-1" type="text" placeholder="Enter HCPCS" value={this.state.searchValue} onChange={this.handleInputChange}
													/>
													<button className="btn btn-info" onClick={this.goToRow}>Find</button>
												</div>
												:null}
											</div>
											:null}
											
											
										</div>
										)}
									  
										{(role === "Demo-Admin" || role === "Demo-User") && (
										  <div className="admin-panel">
											<h5 className="admin-title">User Functions</h5>
											<div className="form-group">
											  <select
												id="userPage"
												className="form-control"
												name="userPage"
												onChange={this.getValue}
											  >
												<option value="">Please Select</option>
												<option value="byHcpcs">Search By HCPCS Code</option>
												<option value="compare">Compare Codes</option>
											  </select>
											</div>
											{this.state.userPage1 ?
												<div className="form-group">
													<label htmlFor="HcpcsCode">Select HCPCS Code</label>
													<select
													  id="HcpcsCode"
													  className="form-control"
													  name="HcpcsCode"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null}
											
											{this.state.userPage1 ?
												<div className="form-group">
													<label htmlFor="policy">Select Policy</label>
													<select
													  id="policy"
													  className="form-control"
													  name="policy"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {policyOption}
													</select>
												</div>
											:null}
											
											{this.state.userPage1 ?
												<div className="form-group">
													<label htmlFor="policyLocation">Select Location</label>
													<select
													  id="policyLocation"
													  className="form-control"
													  name="policyLocation"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {filterOption}
													</select>
												</div>
											:null}
											
											{this.state.userPage2 ?
												<div className="form-group">
													<label htmlFor="HcpcsCode1">Select First HCPCS Code</label>
													<select
													  id="HcpcsCode1"
													  className="form-control"
													  name="HcpcsCode1"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null} 
											
											{this.state.userPage2 ?
												<div className="form-group">
													<label htmlFor="HcpcsCode2">Select Second HCPCS Code</label>
													<select
													  id="HcpcsCode2"
													  className="form-control"
													  name="HcpcsCode2"
													  onChange={this.getValue}
													>
													  <option value="">Please Select</option>
													  {codeOption}
													</select>
												</div>
											:null}
											
										  </div>
										)}
									</div>
								</div>
							  </div>
							</aside>
							
							<div className={'content-wrapper container'} >
								
								{isHomePage ?
									<div className="home-page">
									<h3 className='page-title'>AOPA Coding Pro</h3>
									<div className="l-code-logo"><img src="/L-logo.png" alt="L-code-Explorer" /></div>
									</div>
								:null}
								
								{this.state.selectedSetName != '' && dataSetRows ?
								<div className="data-set-page">
									
									<h3 className='page-title'>DataSet - {this.state.selectedSetName} <button type="button" className="btn btn-link iball-icon"> <i className="fa fa-info-circle" aria-hidden="true" onClick={this.dataSetsDetails}></i></button><button className="btn" onClick={() => this.handleEditDataSet(setObject)}><i className="fa fa-edit"></i></button></h3>
									
									<p><b>V-{moment(setObject.ModifiedDate).format('MMDDYYYYHHmmss')}</b></p>
									<DataTable
										title=""
										columns={this.getColumns()}
										data={dataSetRows}
										pagination
										paginationPerPage={10}
										paginationRowsPerPageOptions={[10, 25, 50, 100]}
										paginationDefaultPage={currentPage}
										paginationResetDefaultPage={this.state.resetPaginationToggle}
										highlightOnHover
										striped
										responsive
										noDataComponent="No records found"
										customStyles={customStyles}
										conditionalRowStyles={conditionalRowStyles}
									/>
									<div className="data-set-bottom">
										<h6>Last File Upload - {moment(setObject.CreatedDate).format('MM-DD-YYYY HH:mm:ss')}</h6>
										<h6>Last Edit - {moment(setObject.ModifiedDate).format('MM-DD-YYYY HH:mm:ss')}</h6>
										{this.state.selectedSetName && dataSetRows ?
										<div className="mg-download">
											<button className="btn btn-info" onClick={this.downloadLatestData}>Download Latest Version</button>
										</div>
										:null}
									</div>
								</div>
								:null}
								
								
								
								{this.state.showCombinedDataTable && combineData ?
								<div className="data-set-page">
									<h3 className='page-title'>Combined Data</h3>
									<DataTable
										title=""
										columns={this.getColumns2()}
										data={combineData}
										pagination
										paginationPerPage={10}
										paginationRowsPerPageOptions={[10, 25, 50, 100]}
										paginationDefaultPage={currentPage}
										highlightOnHover
										striped
										responsive
										noDataComponent="No records found"
										customStyles={customStyles}
										conditionalRowStyles={conditionalRowStyles}
									/>
									{Object.keys(combineData).length > 0 && (
									<div className="data-set-bottom">
										<h6>Last Updated - {moment(this.state.combinedLastDate).format('MM-DD-YYYY HH:mm:ss')}</h6>
										<div className="mg-download">
											<button className="btn btn-info" onClick={this.downloadCombinedData}>Download Full Data Sets</button>
										</div>
									</div>
									)}
								</div>
								:null}
								
								
								
								
								{this.state.editCompany ?
								<div className="l-code-logo2"><img src="/cm.png" alt="L-code-Explorer" /></div>
								:null}
								
								{this.state.editUser ?
								<div className="l-code-logo3"><img src="/us.png" alt="L-code-Explorer" /></div>
								:null}
								{showUpdatePolicy ?
								<div className="page-content-area">
									<div className="page-header">
										<div className="mg-title"><h5>Update Policy File</h5></div>
										<div className="mg-upload">
										  <input type="file" ref={this.fileInputRef} style={{ display: "none" }}/>
										  <button className="btn btn-info" onClick={this.handleButtonClick}>
											Upload New File
										  </button>
										</div>
										<div className="mg-last-date">
										Last Updated : 02/11/2026 01:30:22
										</div>
										
									</div>
									<p></p>
									<div className="policy-table">
									<table className="table table-bordered user-table table-sm"> 
										<thead>
										  <tr>
											{columns.map((col) => (
											  <th key={col}>{col}</th>
											))}
										  </tr>
										</thead>
										<tbody>
										  {policyData.map((row, index) => (
											<tr key={index}>
											  {columns.map((col) => (
												<td key={col}>
												  {typeof row[col] === "object"
													? JSON.stringify(row[col])
													: row[col]}
												</td>
											  ))}
											</tr>
										  ))}
										</tbody>
									  </table>
									  </div>
								</div>
								:null}
								{showUpdateImage && LCode ? 
								<div className="page-content-area">
									<div className="page-header">
										<div className="mg-title"><h5>Update Image</h5></div>	
									</div>
									<p></p>
									<div className="policy-details">
										<div className="row">
											<div className="col-sm-4">
												<div className="code-img">
													<img src={"/"+LCode+".jpg"} alt={LCode} />
												</div>
												<div className="mg-upload-2">
												  <input type="file" ref={this.fileInputRef} style={{ display: "none" }}/>
												  <button className="btn btn-info" onClick={this.handleButtonClick}>
													Change Image
												  </button>
												</div>
												<div className="mg-upload-2">
												  <input type="file" ref={this.fileInputRef} style={{ display: "none" }}/>
												  <button className="btn btn-info" onClick={this.handleButtonClick}>
													Add Additional Images
												  </button>
												</div>
											</div>
											<div className="col-sm-8">
											  <div className="code-details"><p><b>Policy: </b></p><p>{LCodeDetails['Policy']}</p></div>
											  <div className="code-details"><p><b>HCPCS: </b></p><p>{LCodeDetails['HCPCS']}</p></div>
											  <div className="code-details"><p><b>HCPCS Description: </b></p><p>{LCodeDetails['HCPCS Descriptor']}</p></div>
											  <div className="code-details"><p><b>Policy-Coverage Criteria: </b></p><p>{LCodeDetails['Policy-Coverage Criteria']}</p></div>
											</div>
										</div>
									</div>
									
								</div>
								:null}
								
								{this.state.userPage1 && HcpcsCode && HcpcsDetails ? 
								<div className="page-content-area">
									
									<div className="policy-details">
										<div className="row">
											<div className="col-sm-4">
												<div className="code-img">
													<img src={"/"+HcpcsCode+".jpg"} alt={HcpcsCode} />
												</div>
												<div className="code-details2"><p><h5>Policy: </h5></p><p>{HcpcsDetails['Policy']}</p></div>
												<div className="code-details2"><p><h5>HCPCS: </h5></p><p>{HcpcsDetails['HCPCS']}</p></div>
												<div className="code-details2"><p><h5>HCPCS Description: </h5></p><p>{HcpcsDetails['HCPCS Descriptor']}</p></div>
											</div>
											<div className="col-sm-8">
											{policyDataHtml}
											</div>
										</div>
									</div>
									
								</div>
								:null}
								
								{this.state.userPage2 && HcpcsCode1 && HcpcsCode2 ? 
								<div className="page-content-area">
									
									<div className="policy-details">
										<div className="row">
											<div className="col-sm-1">&nbsp;</div>
											<div className="col-sm-4">
												<div className="code-img">
													<img src={"/"+HcpcsCode1+".jpg"} alt={HcpcsCode1} />
												</div>
												<div className="code-details2"><p><h5>Policy: </h5></p><p>{HcpcsDetails1['Policy']}</p></div>
												<div className="code-details2"><p><h5>HCPCS: </h5></p><p>{HcpcsDetails1['HCPCS']}</p></div>
												<div className="code-details2"><p><h5>HCPCS Description: </h5></p><p>{HcpcsDetails1['HCPCS Descriptor']}</p></div>
												<div className="code-details2"><p><h5>Ceiling: </h5></p><p>{HcpcsDetails1['Ceiling']}</p></div>
											</div>
											<div className="col-sm-1">&nbsp;</div>
											<div className="col-sm-4">
												<div className="code-img">
													<img src={"/"+HcpcsCode2+".jpg"} alt={HcpcsCode2} />
												</div>
												<div className="code-details2"><p><h5>Policy: </h5></p><p>{HcpcsDetails2['Policy']}</p></div>
												<div className="code-details2"><p><h5>HCPCS: </h5></p><p>{HcpcsDetails2['HCPCS']}</p></div>
												<div className="code-details2"><p><h5>HCPCS Description: </h5></p><p>{HcpcsDetails2['HCPCS Descriptor']}</p></div>
												<div className="code-details2"><p><h5>Ceiling: </h5></p><p>{HcpcsDetails2['Ceiling']}</p></div>
											</div>
										</div>
									</div>
									
								</div>
								:null}
								
								<div className="modal fade" id="editRowPopup" tabIndex="-1">
								  <div className="modal-dialog">
									<div className="modal-content">

									  <div className="modal-header">
										<h5 className="modal-title">Edit {this.state.selectedSetName}</h5>
										<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
									  </div>

									  <div className="modal-body">
										{this.state.editRow &&
										  Object.keys(this.state.editRow).map((key) => {
										if (key === "HCPCS" || key === "updated_at" || key === "__rowNum__") return null;

											return (
											  <div className="op-input" key={key}>
												<label>{key.replace(/([A-Z])/g, " $1").trim()}: </label>
												<DebounceInput
												  debounceTimeout={4000}
												  type="text"
												  className="form-control"
												  value={this.state.editRow[key]}
												  name={key}
												  onChange={this.getValue}
												/>
											  </div>
											);
										  })}
									  </div>

									  {/* Footer */}
									  <div className="modal-footer">
										<button type="button" className="btn btn-primary" onClick={this.editRowUpdate}>
										  Update
										</button>
										<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
										  Close
										</button>
									  </div>

									</div>
								  </div>
								</div>
								
								<div className="modal fade" id={"uploadSetPopup"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
											</div>
											<div className="modal-body">
												Add New DataSet, Replace or only Modify the changes!
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSet2} data-bs-dismiss="modal">Add New</button>
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSet2} data-bs-dismiss="modal">Replace</button>
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSet2} data-bs-dismiss="modal">Modify</button>
												<button type="button" className="btn btn-danger float-right" data-bs-dismiss="modal">Close</button>
											</div>
										</div>
									</div>
								</div>
								
								<div className="modal fade" id={"DataSetsDetails"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-body">
												<div className={"data-set-name"}>
													<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
													<div className={"data-set-del"}><b>DataSet Name : </b><b>{setObject.DataSetName}</b></div>
													<div className={"data-set-del"}><b>File Prefix : </b>{setObject.FilePrefix}</div>
													<div className={"data-set-del"}><b>Description : </b>{setObject.Description}</div>
													<div className="data-set-del">
													  <b>Notes : </b>
													  {(setObject.DataSetNotes || '').split('\n').map((line, index) => (
														<div key={index}>{line}</div>
													  ))}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								
								<div className="modal fade" id={"DataSetsEditDetails"} tabIndex="-1">
									<div className="modal-dialog">
										<div className="modal-content">
											<div className="modal-header">
												<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
											</div>
											<div className="modal-body">
												<div className="form-group">
													<label>DataSet Name:</label>
													<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="DataSetName" onChange={this.getValue} value={this.state.DataSetName ? this.state.DataSetName : setObject.DataSetName} />
												</div>
												
												<div className="form-group">
													<label>File Prefix:</label>
													<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="FilePrefix" onChange={this.getValue} value={this.state.FilePrefix ? this.state.FilePrefix : setObject.FilePrefix} />
												</div>
												
												<div className="form-group">
													<label>Description:</label>
													<DebounceInput debounceTimeout={4000} type="text" className="form-control" name="Description" onChange={this.getValue} value={this.state.Description ? this.state.Description : setObject.Description} />
												</div>
												
												<div className="form-group">
													<label>Note:</label>
													<DebounceInput element="textarea" rows="2" debounceTimeout={4000} className="form-control" name='DataSetNote' onChange={this.getValue} />
												</div>		
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-primary" onClick={this.uploadDataSetDetails} data-bs-dismiss="modal">Save</button>
												<button type="button" className="btn btn-danger float-right" data-bs-dismiss="modal">Close</button>
											</div>
										</div>
									</div>
								</div>

								
							</div>
						</div>
					</div>
				</div>
            </div>
        );
    }
}

export default AopaCode;